<div style="display: block" *ngIf="!this.isNewRapportino">
  <div style="height: 10%; width: 100%; display: flex">
    <div style="width: 60%">
      <h3><b>Programmazione giorno: {{this.TransformDataFormatToShow(this.selectedDay)}}<br><b>Ore
        previste totali: {{this.countOrePreviste()}}</b><br>
        <b style="color: red">Ore
          effettive totali: {{this.countOreEffettive()}}</b>


      </b></h3>
    </div>
    <div style="width: 40%;
    display: grid;
    text-align: right;
    justify-content: flex-end;">
      <button title="Salva" (click)="closeDialog()" mat-icon-button color="warn"
              aria-label="icon-button save">
        <mat-icon>close</mat-icon>
      </button>
      <button title="Nuova programmazione attività" (click)="newProgrammazione()" *ngIf="!this.isAddNew" mat-icon-button
              style="color: rgb(9,94,9)"
      >
        <mat-icon>post_add</mat-icon>
      </button>
      <button title="Chiudi nuova programmazione attività" (click)="newProgrammazione()" *ngIf="this.isAddNew"
              mat-icon-button style="color: rgb(9,94,9)"
      >
        <mat-icon>remove</mat-icon>
      </button>
    </div>
  </div>

  <hr class="riga" style="color:{{this.apiService.dashColor}}; margin: 0px !important">

  <div>
    <div *ngIf="this.isAddNew"
         style=" display: flex; padding: 15px; padding-left: 0px !important;">

      <div style="width: 100%; margin-left: 1%; margin-right: 1%" *ngIf="this.dataMaskToSaveProg">
        <ng-container *ngFor="let field of this.dataMaskToSaveProg.fields">
          <ng-container
            *ngIf="field.name == 'To' || field.name == 'COMBO681_154' || field.name == 'NUMERIC678_154' || field.name == 'NUMERIC679_154'">
            <ng-container [ngSwitch]="field.className">
              <mat-form-field *ngSwitchCase="'ToFieldDTO'" style="width: 47%;"
                              appearance="outline">
                <!--A-->
                <mat-label>{{field.description}}</mat-label>
                <mat-chip-list #chipList aria-label="MultiValue">
                  <div style="width: 100%; display: flex;">
                    <div style="width: 80%">
                      <mat-chip *ngFor="let element of this.mapAddressBookToSee.get(field.name)" [selectable]="false"
                                [disabled]="field.locked" style="height: fit-content;"
                                [removable]="removable" (removed)="removeAddressBookActivity(element, field.name)"
                                [value]="element.id">
                        {{element.name}}
                        <mat-icon matChipRemove *ngIf="removable && !(field.locked)">cancel</mat-icon>
                      </mat-chip>
                      <input *ngIf="this.mapAddressBookToSee.size == 0"
                             placeholder="{{'labels.insertDestination' | translate}}..."
                             (input)="this.checkAutocompleteToActivity(field)"
                             ngModel [(ngModel)]="toCtrl" #toField
                             [matAutocomplete]="auto" matInput [disabled]="field.locked"
                             [matChipInputFor]="chipList" [ngModelOptions]="{standalone: true}"
                             [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                      >
                    </div>
                    <div style="width: 20%; text-align: right">
                      <button matSuffix mat-icon-button (click)="openAddressBookActivity(field)"
                              style="color: {{this.apiService.dashColor}}" [disabled]="field.locked">
                        <mat-icon>notes</mat-icon>
                      </button>
                    </div>
                  </div>
                </mat-chip-list>
                <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                  (optionSelected)="addSelectedActivity($event, field)">
                  <mat-option *ngFor="let to of toFieldData.data" [value]="to">
                    {{to[3]}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <ng-container *ngSwitchCase="'AdditionalFieldTableDTO'">
                <mat-form-field style="width: 47%; margin: 2%"
                                *ngIf="this.mapAddressBookToSee.size > 0"
                                appearance="outline">
                  <!--TableDTO-->
                  <mat-label>{{field.description}}
                    <ng-container *ngIf="this.oreRimasteAttivita"> (Ore residue: {{this.oreRimasteAttivita}})
                    </ng-container>
                  </mat-label>
                  <input ngModel [value]="field.value || ''"
                         [(ngModel)]="this.attivitaValue" name="{{field.name}}"
                         (input)="this.manualActivity(field.name)"
                         [id]="field.name" [required]="field.required" [disabled]="field.locked"
                         maxlength="{{field.numMaxChar || 100}}" matInput
                         placeholder="{{field.description}}">
                  <button mat-button matSuffix mat-icon-button style="color: {{this.apiService.dashColor}}"
                          (click)="openTableDTOActivity(field)">
                    <mat-icon>table_chart</mat-icon>
                  </button>
                </mat-form-field>
              </ng-container>
              <ng-container *ngSwitchCase="'AdditionalFieldComboDTO'">
                <ng-container *ngIf="field.limitToList">
                  <mat-form-field *ngIf="this.mapAddressBookToSee.size > 0"
                                  style="width: 47%; margin: 2%"
                                  appearance="outline">
                    <!--Tipo documento-->
                    <mat-label>{{field.description}}(Ore residue: {{this.oreResidue}})</mat-label>
                    <mat-select [id]="field.name" [value]="field.value || ''"
                                [required]="field.required"
                                (selectionChange)="this.checkComboAssociationsActivity(field)"
                                [(ngModel)]="dataMaskToSaveProg[field.name]" name="{{field.name}}"
                                [disabled]="field.locked">
                      <mat-option>--{{'labels.cancel' | translate }}--</mat-option>
                      <mat-option *ngFor="let value of this.comboValues[field.name]"
                                  [value]="value.keyField">
                        {{value.selectField}}
                      </mat-option>

                    </mat-select>

                  </mat-form-field>
                </ng-container>
                <ng-container *ngIf="!field.limitToList">

                  <mat-form-field style="width: 45%"
                                  style="width: 47%; margin: 2%" *ngIf="this.mapAddressBookToSee.size > 0"
                                  appearance="outline">
                    <!--Tipo documento-->
                    <mat-label>{{field.description}}
                      <ng-container *ngIf="this.oreResidue"> (Ore residue: {{this.oreResidue}})</ng-container>
                    </mat-label>
                    <input ngModel
                           name="{{field.name}}"
                           [(ngModel)]="this.comboControl[field.name]"
                           [id]="field.name" [required]="field.required" (input)="checkFieldActivity(field)"
                           [disabled]="field.locked" [ngModelOptions]="{standalone: true}"
                           maxlength="{{field.numMaxChar || 100}}" matInput
                           placeholder="{{field.description}}" [matAutocomplete]="auto">
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                      [displayWith]="displayFnActivity.bind(this, field)">
                      <ng-container *ngFor="let value of this.comboValues[field.name]">
                        <mat-option *ngIf="value.visible"
                                    [value]="value">
                          {{value.selectField}}
                        </mat-option>
                      </ng-container>

                    </mat-autocomplete>
                    <!--<mat-select [id]="field.name" [value]="field.value || ''"
                                [required]="field.required" (selectionChange)="this.checkFormula()"
                                (selectionChange)="this.checkComboAssociations(field)"
                                [(ngModel)]="dataMaskToSaveProg[field.name]" name="{{field.name}}"
                                [disabled]="field.locked">
                      <mat-option>--Cancella--</mat-option>
                      <mat-option *ngFor="let value of this.comboValues[field.name]"
                                  [value]="value.keyField">
                        {{value.selectField}}
                      </mat-option>

                    </mat-select>-->

                  </mat-form-field>
                </ng-container>
              </ng-container>

            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngFor="let field of this.dataMaskToSaveProg.fields">
          <div *ngIf="field.name == 'NUMERIC678_154' || field.name == 'NUMERIC679_154' || field.name == 'TESTO12_12'">
            <ng-container [ngSwitch]="field.className" *ngIf="this.comboControl['COMBO681_154']">
              <ng-container *ngSwitchCase="'AdditionalFieldDoubleDTO'">
                <mat-form-field style="width: 45%"
                                appearance="outline"
                >
                  <mat-label>{{field.description}}</mat-label>
                  <input [ngClass]="{
                         'red': field.name == 'NUMERIC679_154'
                          }" ngModel [value]="field.value"
                         [id]="field.name" type="number" [required]="field.required"
                         [disabled]="field.locked" (input)="this.changedOre(field)"
                         [(ngModel)]="this.ore[field.name]" name="{{field.name}}"
                         maxlength="{{field.numMaxChar || 100}}" matInput
                         placeholder="{{field.description}}">
                </mat-form-field>
              </ng-container>
              <ng-container *ngSwitchCase="'AdditionalFieldStringDTO'">
                <mat-form-field
                  style="width: 100%"
                  appearance="outline">
                  <!--Tipo documento-->
                  <mat-label>{{field.description}}</mat-label>
                  <ng-container *ngIf="field.numMaxChar > 400">
                                      <textarea ngModel [value]="field.value || ''"
                                                [(ngModel)]="this.newActivityDescription" name="{{field.name}}"
                                                (input)="this.updateDescription()"
                                                [id]="field.name" [required]="field.required" [disabled]="field.locked"
                                                maxlength="{{field.numMaxChar || 100}}" matInput
                                                rows="{{field.numRows}}" autosize
                                                style="resize: none;width:95%;"
                                                placeholder="{{field.description}}"></textarea>
                  </ng-container>
                  <ng-container *ngIf="field.numMaxChar <= 400">
                    <input ngModel [value]="field.value || ''" (input)="this.updateDescription()"
                           [(ngModel)]="this.newActivityDescription" name="{{field.name}}"
                           [id]="field.name" [required]="field.required"
                           [disabled]="field.locked" [ngModelOptions]="{standalone: true}"
                           maxlength="{{field.numMaxChar || 100}}" matInput
                           placeholder="{{field.description}}">
                  </ng-container>
                </mat-form-field>
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
        <button mat-stroked-button style="width: 100%; color: green; margin: 0px !important;"
                *ngIf="this.comboControl['COMBO681_154']" (click)="this.addNewActivity()">Inserisci attività
        </button>
      </div>
      <!-- <div style="width: 40%">
         <mat-form-field class="example-form-field" style="margin-left: 10px">
           <mat-label style="font-size: medium;">Ore previste</mat-label>
           <input matInput type="number" style="
     font-size: x-large;" [(ngModel)]="event.hourNumber">
           <button *ngIf="event.hourNumber" matSuffix mat-icon-button aria-label="Clear" (click)="event.hourNumber=''">
             <mat-icon>close</mat-icon>
           </button>
         </mat-form-field>
         <mat-form-field class="example-form-field" style="margin-left: 10px">
           <mat-label style="
     font-size: medium;">Ore effettive
           </mat-label>
           <input matInput type="number" style="color: red !important;
     font-size: x-large;" [(ngModel)]="event.oreEffettive">
           <button *ngIf="event.oreEffettive" matSuffix mat-icon-button aria-label="Clear" (click)="event.oreEffettive=''">
             <mat-icon>close</mat-icon>
           </button>
         </mat-form-field>
       </div>-->
    </div>
    <ng-container *ngFor="let event of this.events">
      <div *ngIf="event.tecnico == this.selectedUser || this.selectedUser == ''"
           style=" display: flex; padding: 15px; padding-left: 0px !important;border-left: 3px solid {{event['extraColor']}};border-right: 3px solid {{event['extraColor']}};border-top: 1px solid black;">
        <div style="width: 7%; margin: auto">
          <button mat-icon-button style="color:rgba(26,143,0,0.78);" title="Genera rapportino (IN FASE DI TEST)"
                  *ngIf="!event['isRapportinato'] && !event['oreEffettive'] == 0 && event['oreEffettive']"
                  disabled="false"
                  (click)="this.ngOnInitMask(event)">
            <mat-icon mat-list-icon>note_add</mat-icon>
          </button>
          <button mat-icon-button style="color:rgba(26,143,0,0.78);" *ngIf="event['isRapportinato']"
                  title="Programmazione rapportinata"
                  disabled="true">
            <mat-icon mat-list-icon>done</mat-icon>
          </button>
          <button mat-icon-button style="color: {{this.apiService.dashColor}};" title="Vai al progetto"
                  (click)="this.openProject(event['progettoDocN'])">
            <mat-icon>arrow_circle_right</mat-icon>
          </button>
          <button mat-icon-button style="color:rgba(0,0,143,0.78);" title="Modifica attività programmata" *ngIf="false">
            <mat-icon mat-list-icon>edit</mat-icon>
          </button>
          <button mat-icon-button style="color: red;" title="Elimina attività programmata"
                  (click)="this.deleteEvent(event)">
            <mat-icon mat-list-icon>delete</mat-icon>
          </button>
        </div>
        <div
          style="width: 51%; margin-left: 1%; margin-right: 1%; display: flex; flex-direction: column; justify-content: space-between;">
          <div mat-line title="{{event['attivita']}}"><b style="font-size: medium;">{{event['title']}}</b></div>
          <div mat-line title="{{event['descrizione']}}"><b
            style="font-size: small;">Descrizione:</b><br>
            <mat-form-field style = "width: 100%"  >
              <textarea  rows="3" (ngModelChange) = "this.updateEventWhenStopTyping(event)" matInput [(ngModel)]="event['descrizione']" [disabled] = "event['isRapportinato'] == 1"></textarea>
            </mat-form-field>
          </div>
          <div mat-line title="{{event['tecnico']}}"
               style="margin-top: auto; color: {{event['extraColor']}}">{{event['tecnico']}}</div>
        </div>
        <div style="width: 40%">
          <mat-form-field class="example-form-field" style="margin-left: 10px">
            <mat-label style="font-size: medium;">Ore previste</mat-label>
            <input matInput type="number" style="
    font-size: x-large;" [(ngModel)]="event.hourNumber" (ngModelChange)="this.updateEvent(event)">
            <button *ngIf="event.hourNumber" matSuffix mat-icon-button aria-label="Clear" (click)="event.hourNumber=''">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field class="example-form-field" style="margin-left: 10px">
            <mat-label style="
    font-size: medium;">Ore effettive
            </mat-label>
            <input matInput type="number" style="color: red !important;
    font-size: x-large;" [(ngModel)]="event.oreEffettive" (ngModelChange)="this.updateEvent(event)">
            <button *ngIf="event.oreEffettive" matSuffix mat-icon-button aria-label="Clear"
                    (click)="event.oreEffettive=''">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </div>

</div>

<div style="display: block" *ngIf="this.isNewRapportino">
  <div style="height: 10%; width: 100%; display: flex">
    <div style="width: 60%">
      <h3><b>Rapportino giorno: {{this.TransformDataFormatToShow(this.selectedDay)}}

      </b></h3>
    </div>
    <div style="width: 40%;
    display: grid;
    text-align: right;
    justify-content: flex-end;">
      <button title="Salva" (click)="closeDialog()" mat-icon-button color="warn"
              aria-label="icon-button save">
        <mat-icon>close</mat-icon>
      </button>

    </div>
  </div>

  <hr class="riga" style="color:{{this.apiService.dashColor}}; margin: 0px !important">

  <form class="flexform" style="margin-top: 2%" (input)="checkInputFormula()">
    <!--mat-grid-list [cols]="breakpoint" cols="4" rowHeight="100px" (window:resize)="onResize($event)"-->
    <ng-container *ngFor="let field of fields">
      <!--mat-grid-tile [colspan]="4"
                     [rowspan]="1" class="gridtile" [ngSwitch]="field.className"
                     *ngIf="field.visible && field.className != 'ProtocolDateFieldDTO'"-->
      <ng-container [ngSwitch]="field.className"
                    *ngIf="field.visible && field.className != 'ProtocolDateFieldDTO'"
                    style="height:fit-content; width: 100%;">
        <!-- NumberFieldDTO -->
        <mat-form-field *ngSwitchCase="'NumberFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                        appearance="outline">
          <mat-label>{{field.description}}</mat-label>
          <input ngModel [ngModelOptions]="{standalone: true}" [id]="field.name"
                 [(ngModel)]="dataMaskToSave[field.name]"
                 [required]="field.required"
                 [disabled]="field.locked" [value]="field.value || ''"
                 maxlength="{{field.numMaxChar || 100}}"
                 matInput placeholder="{{field.description}}">
        </mat-form-field>
        <!-- DocumentDateFieldDTO -->
        <ng-container *ngSwitchCase="'DocumentDateFieldDTO'">
          <mat-form-field *ngIf="field.value == '0001-01-01T00:00:00'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                          appearance="outline"
          >
            <!--AdditionalFieldDateTimeDTO-->
            <mat-label>{{field.description}}</mat-label>
            <input style="color:#29648A;" [value]="field.value || ''" matInput
                   [matDatepicker]="picker" onkeydown="return false;"
                   [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                   [id]="field.name" [required]="field.required" (dateChange)="this.checkInputFormula()"
                   [disabled]="field.locked" (click)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker disabled="{{field.locked}}" #picker color="primary"></mat-datepicker>

          </mat-form-field>
          <mat-form-field *ngIf="field.value != '0001-01-01T00:00:00'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                          appearance="outline"
          >
            <!--AdditionalFieldDateTimeDTO-->
            <mat-label>{{field.description}}</mat-label>
            <input style="color:#29648A;" [value]="'' || ''" matInput
                   [matDatepicker]="picker" onkeydown="return false;"
                   [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                   [id]="field.name" [required]="field.required" (dateChange)="this.checkInputFormula()"
                   [disabled]="field.locked" (click)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker disabled="{{field.locked}}" #picker color="primary"></mat-datepicker>

          </mat-form-field>
        </ng-container>
        <!-- SubjectFieldDTO -->
        <mat-form-field *ngSwitchCase="'SubjectFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                        appearance="outline">
          <mat-label>{{field.description}}</mat-label>
          <input ngModel [ngModelOptions]="{standalone: true}" [value]="field.value || ''"
                 [(ngModel)]="dataMaskToSave[field.name]"
                 [id]="field.name" [required]="field.required" [disabled]="field.locked"
                 maxlength="{{field.numMaxChar || 100}}" matInput
                 placeholder="{{field.description}}">
        </mat-form-field>
        <ng-container *ngSwitchCase="'AdditionalFieldBooleanDTO'">

          <div style="text-align: left !important; margin-bottom: 2%; margin-top: 1%;"
               [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
               appearance="outline">
            <mat-slide-toggle [id]="field.name" style="color: {{this.apiService.dashColor}}" color="warn"
                              [required]="field.required" (toggleChange)="this.checkFormula()"
                              [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                              [disabled]="field.locked">{{field.description}}</mat-slide-toggle>
            <!--MultiValueDTO-->
          </div>
        </ng-container>
        <!-- ToFieldDTO -->
        <mat-form-field *ngSwitchCase="'ToFieldDTO'"
                        [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}" appearance="outline">
          <!--A-->
          <mat-label>{{field.description}}</mat-label>
          <mat-chip-list #chipList aria-label="MultiValue">
            <div style="width: 100%; display: flex;">
              <div style="width: 80%">
                <mat-chip *ngFor="let element of this.mapAddressBookToSee.get(field.name)" [selectable]="false"
                          [disabled]="field.locked"
                          [removable]="removable" (removed)="removeAddressBook(element, field.name)"
                          [value]="element.id">
                  {{element.name}}
                  <mat-icon matChipRemove *ngIf="removable && !(field.locked)">cancel</mat-icon>
                </mat-chip>
                <input
                  placeholder="{{'labels.insertDestination' | translate}}..."
                  (input)="this.checkAutocompleteTo(field)"
                  ngModel [(ngModel)]="toCtrl" #toField
                  [matAutocomplete]="auto" matInput [disabled]="field.locked"
                  [matChipInputFor]="chipList" [ngModelOptions]="{standalone: true}"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                >
              </div>
              <div style="width: 20%; text-align: right">
                <button matSuffix mat-icon-button (click)="openAddressBook(field)"
                        style="color: {{this.apiService.dashColor}}" [disabled]="field.locked">
                  <mat-icon>notes</mat-icon>
                </button>
              </div>
            </div>
          </mat-chip-list>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                            (optionSelected)="addSelected($event, field)">
            <mat-option *ngFor="let to of toFieldData.data" [value]="to">
              {{to[3]}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <!--<ng-container *ngSwitchCase="'ToFieldDTO'">
            <mat-form-field  [ngClass]="{
'form-field': field.columns !== 1,
'form-field-expanded': field.columns === 1
}"
            >
                <mat-label>{{field.description}}</mat-label>
                <mat-chip-list #chipList aria-label="MultiValue" >
                    <div style = "width: 100%; display: flex;">
                        <div style = "width: 80%">
                            <mat-chip *ngFor="let element of this.mapMultiValueToSee.get(field.name)" [selectable]="false" [disabled]="field.locked"
                                      [removable]="removable" (removed)="remove(element, field.name)">
                                {{element}}
                                <mat-icon matChipRemove *ngIf="removable && !(field.locked)">cancel</mat-icon>
                            </mat-chip>
                        </div>
                        <div style = "width: 20%; text-align: right">
                            <button  matSuffix mat-icon-button (click)="openAddressBook(field)" [disabled]="field.locked">
                                <mat-icon>notes</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-chip-list>
            </mat-form-field>
        </ng-container>-->
        <!-- FromFieldDTO -->
        <mat-form-field *ngSwitchCase="'FromFieldDTO'"
                        [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}" appearance="outline">
          <!--DA-->
          <mat-label>{{field.description}}</mat-label>
          <mat-chip-list #chipList aria-label="MultiValue">
            <div style="width: 100%; display: flex;">
              <div style="width: 80%">
                <mat-chip *ngFor="let element of this.mapAddressBookToSee.get(field.name)" [selectable]="false"
                          [disabled]="field.locked"
                          [removable]="removable" (removed)="removeAddressBook(element, field.name)"
                          [value]="element.id">
                  {{element.name}}
                  <mat-icon matChipRemove *ngIf="removable && !(field.locked)">cancel</mat-icon>
                </mat-chip>
                <input
                  placeholder="{{'labels.insertDestination' | translate}}..."
                  (input)="this.checkAutocompleteTo(field)"
                  ngModel [(ngModel)]="fromCtrl" #fromField
                  [matAutocomplete]="auto" matInput [disabled]="field.locked"
                  [matChipInputFor]="chipList" [ngModelOptions]="{standalone: true}"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                >
              </div>
              <div style="width: 20%; text-align: right">
                <button matSuffix mat-icon-button (click)="openAddressBook(field)"
                        style="color: {{this.apiService.dashColor}}" [disabled]="field.locked">
                  <mat-icon>notes</mat-icon>
                </button>
              </div>
            </div>
          </mat-chip-list>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                            (optionSelected)="addSelected($event, field)">
            <mat-option *ngFor="let from of fromFieldData.data" [value]="from">
              {{from[3]}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <!-- CcFieldDTO -->
        <mat-form-field *ngSwitchCase="'CcFieldDTO'"
                        [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}" appearance="outline">
          <!--A-->
          <mat-label>{{field.description}}</mat-label>
          <mat-chip-list #chipList aria-label="MultiValue">
            <div style="width: 100%; display: flex;">
              <div style="width: 80%">
                <mat-chip *ngFor="let element of this.mapAddressBookToSee.get(field.name)" [selectable]="false"
                          [disabled]="field.locked"
                          [removable]="removable" (removed)="removeAddressBook(element, field.name)"
                          [value]="element.id">
                  {{element.name}}
                  <mat-icon matChipRemove *ngIf="removable && !(field.locked)">cancel</mat-icon>
                </mat-chip>
                <input
                  placeholder="{{'labels.insertDestination' | translate}}..."
                  (input)="this.checkAutocompleteTo(field)"
                  ngModel [(ngModel)]="ccCtrl" #ccField
                  [matAutocomplete]="auto" matInput [disabled]="field.locked"
                  [matChipInputFor]="chipList" [ngModelOptions]="{standalone: true}"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                >
              </div>
              <div style="width: 20%; text-align: right">
                <button matSuffix mat-icon-button (click)="openAddressBook(field)"
                        style="color: {{this.apiService.dashColor}}" [disabled]="field.locked">
                  <mat-icon>notes</mat-icon>
                </button>
              </div>
            </div>
          </mat-chip-list>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                            (optionSelected)="addSelected($event, field)">
            <mat-option *ngFor="let cc of ccFieldData.data" [value]="cc">
              {{cc[3]}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <!-- BusinessUnitFieldDTO -->
        <mat-form-field *ngSwitchCase="'BusinessUnitFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                        appearance="outline">
          <!--Aoo-->
          <mat-label>{{'labels.company' | translate}}</mat-label>
          <mat-select [id]="field.name" [value]="field.value || ''"
                      [required]="field.required"
                      [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                      [disabled]="field.locked">
            <mat-option *ngFor="let aoo of nomiAoo" [value]="aoo.code">
              {{aoo.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- DocumentTypeFieldDTO -->
        <mat-form-field *ngSwitchCase="'DocumentTypeFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                        appearance="outline">
          <!--Classe documento, dipende da "Aoo"-->
          <mat-label>{{field.description}}</mat-label>
          <mat-select [id]="field.name" [id]="field.name" [value]="field.value || ''"
                      [required]="field.required"
                      [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                      [disabled]="field.locked">
            <mat-option *ngFor="let documenType of documenTypes" [value]="documenType.id">
              {{documenType.description}} - {{documenType.key}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- OriginFieldDTO -->
        <mat-form-field *ngSwitchCase="'OriginFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                        appearance="outline">
          <!--Origine-->
          <mat-label>{{field.description}}</mat-label>
          <mat-select [id]="field.name" [id]="field.name" [value]="field.value || ''"
                      [required]="field.required"
                      [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                      [disabled]="field.locked">
            <mat-option *ngFor="let originField of originsFields"
                        [value]="originField.value">
              {{originField.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- StateFieldDTO -->
        <mat-form-field *ngSwitchCase="'StateFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}" appearance="outline">
          <!--Stato, dipende da documento-->
          <mat-label>{{field.description}}</mat-label>
          <mat-select [id]="field.name" [id]="field.name" [value]="field.value || ''"
                      [required]="field.required"
                      [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                      [disabled]="field.locked">
            <mat-option *ngFor="let stateField of stateFields" [value]="stateField.id">
              {{stateField.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngSwitchCase="'InstructionFieldDTO'"
             style="background-color: aliceblue; padding: 1%; margin-top: 1%; margin-bottom: 1%"
             [innerHtml]="field.description" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}" appearance="outline" style="text-align: left; color: {{this.apiService.squareColor}}">


        </div>
        <!-- BinderFieldDTO -->
        <mat-form-field *ngSwitchCase="'BinderFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                        appearance="outline">
          <!--Pratiche-->
          <mat-label>{{field.description}}</mat-label>
          <input ngModel [value]="field.value || ''"
                 [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                 [id]="field.name" [required]="field.required" [disabled]="field.locked"
                 maxlength="{{field.numMaxChar || 100}}" matInput
                 placeholder="{{field.description}}">
        </mat-form-field>

        <!-- DocumentDateExpiredFieldDTO -->
        <ng-container *ngSwitchCase="'DocumentDateExpiredFieldDTO'">
          <mat-form-field *ngIf="field.value == '0001-01-01T00:00:00'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                          appearance="outline"
          >
            <!--AdditionalFieldDateTimeDTO-->
            <mat-label>{{field.description}}</mat-label>
            <input style="color:#29648A;" [value]="field.value || ''" matInput
                   [matDatepicker]="picker" onkeydown="return false;"
                   [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                   [id]="field.name" [required]="field.required" (dateChange)="this.checkInputFormula()"
                   [disabled]="field.locked" (click)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker disabled="{{field.locked}}" #picker color="primary"></mat-datepicker>

          </mat-form-field>
          <mat-form-field *ngIf="field.value != '0001-01-01T00:00:00'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                          appearance="outline"
          >
            <!--AdditionalFieldDateTimeDTO-->
            <mat-label>{{field.description}}</mat-label>
            <input style="color:#29648A;" [value]="'' || ''" matInput
                   [matDatepicker]="picker" onkeydown="return false;"
                   [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                   [id]="field.name" [required]="field.required" (dateChange)="this.checkInputFormula()"
                   [disabled]="field.locked" (click)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker disabled="{{field.locked}}" #picker color="primary"></mat-datepicker>

          </mat-form-field>
        </ng-container>

        <!-- ImportantFieldDTO -->
        <mat-form-field *ngSwitchCase="'ImportantFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                        appearance="outline">
          <!--Campo "Importante"-->
          <mat-label>{{field.description}}</mat-label>
          <input ngModel [value]="field.value || ''"
                 [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                 [id]="field.name" [required]="field.required" [disabled]="field.locked"
                 maxlength="{{field.numMaxChar || 100}}" matInput
                 placeholder="{{field.description}}">
        </mat-form-field>

        <!-- SendersFieldDTO -->
        <mat-form-field *ngSwitchCase="'SendersFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                        appearance="outline">
          <!--Altri da-->
          <mat-label>{{field.description}}</mat-label>
          <input ngModel [value]="field.value || ''"
                 [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                 [id]="field.name" [required]="field.required" [disabled]="field.locked"
                 maxlength="{{field.numMaxChar || 100}}" matInput
                 placeholder="{{field.description}}">
        </mat-form-field>

        <!-- OriginalFieldDTO -->
        <mat-form-field *ngSwitchCase="'OriginalFieldDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                        appearance="outline">
          <!--Originale-->
          <mat-label>{{field.description}}</mat-label>
          <input ngModel [value]="field.value || ''"
                 [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                 [id]="field.name" [required]="field.required" [disabled]="field.locked"
                 maxlength="{{field.numMaxChar || 100}}" matInput
                 placeholder="{{field.description}}">
        </mat-form-field>

        <!-- AdditionalFieldGroupDTO -->
        <h3 *ngSwitchCase="'AdditionalFieldGroupDTO'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
            style="width: 90%; margin-bottom: 2%; color: {{this.dashColor}}"
            appearance="outline">
          <!--Campo aggiuntivo "Generale"-->
          {{field.description}}<br>
          <hr>
        </h3>

        <!-- AdditionalFieldStringDTO -->
        <ng-container *ngSwitchCase="'AdditionalFieldStringDTO'">
          <mat-form-field
            [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
            appearance="outline">
            <!--Tipo documento-->
            <mat-label>{{field.description}}</mat-label>
            <ng-container *ngIf="field.numMaxChar > 400">
                                      <textarea ngModel [value]="field.value || ''"
                                                [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                                                [id]="field.name" [required]="field.required" [disabled]="field.locked"
                                                maxlength="{{field.numMaxChar || 100}}" matInput
                                                rows="{{field.numRows}}" autosize
                                                style="resize: none;width:95%;"
                                                placeholder="{{field.description}}"></textarea>
            </ng-container>
            <ng-container *ngIf="field.numMaxChar <= 400">
              <input ngModel [value]="field.value || ''"
                     [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                     [id]="field.name" [required]="field.required"
                     [disabled]="field.locked" [ngModelOptions]="{standalone: true}"
                     maxlength="{{field.numMaxChar || 100}}" matInput
                     placeholder="{{field.description}}">
            </ng-container>
          </mat-form-field>
        </ng-container>
        <!-- AdditionalFieldTableDTO -->
        <ng-container *ngSwitchCase="'AdditionalFieldTableDTO'">
          <mat-form-field
            [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
            appearance="outline" (click)="openTableDTO(field)">
            <!--TableDTO-->
            <mat-label>{{field.description}}</mat-label>
            <input ngModel [value]="field.value || ''"
                   [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                   [id]="field.name" [required]="field.required" [disabled]="field.locked"
                   maxlength="{{field.numMaxChar || 100}}" matInput
                   placeholder="{{field.description}}">
            <button mat-button matSuffix mat-icon-button style="color: {{this.dashColor}}">
              <mat-icon>table_chart</mat-icon>
            </button>
          </mat-form-field>
        </ng-container>
        <!-- AdditionalFieldMultivalueDTO -->

        <ng-container *ngSwitchCase="'AdditionalFieldMultivalueDTO'">
          <mat-form-field [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
          >
            <!--MultiValueDTO-->
            <mat-label>{{field.description}}</mat-label>
            <mat-chip-list #chipList aria-label="MultiValue" [required]="field.required">
              <div style="width: 100%; display: flex;">
                <div style="width: 80%">
                  <mat-chip *ngFor="let element of this.mapMultiValueToSee.get(field.name)"
                            [selectable]="false"
                            [disabled]="field.locked"
                            [removable]="removable" (removed)="remove(element, field.name)">
                    {{element}}
                    <mat-icon matChipRemove *ngIf="removable && !(field.locked)">cancel</mat-icon>
                  </mat-chip>
                </div>
                <div style="width: 20%; text-align: right; height: 60px;">
                  <button matSuffix mat-icon-button (click)="openMultiValueDTO(field)"
                          style="color: {{this.apiService.dashColor}}" [disabled]="field.locked">
                    <mat-icon>notes</mat-icon>
                  </button>
                </div>
              </div>
            </mat-chip-list>

          </mat-form-field>
        </ng-container>
        <!-- AdditionalFieldComboDTO -->
        <ng-container *ngSwitchCase="'AdditionalFieldComboDTO'">
          <ng-container *ngIf="field.limitToList">
            <mat-form-field
              [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
              appearance="outline">
              <!--Tipo documento-->
              <mat-label>{{field.description}}</mat-label>
              <mat-select [id]="field.name" [value]="field.value || ''"
                          [required]="field.required" (selectionChange)="this.checkFormula()"
                          (selectionChange)="this.checkComboAssociations(field)"
                          [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                          [disabled]="field.locked">
                <mat-option>--{{'labels.cancel' | translate }}--</mat-option>
                <mat-option *ngFor="let value of this.comboValues[field.name]"
                            [value]="value.keyField">
                  {{value.selectField}}
                </mat-option>

              </mat-select>

            </mat-form-field>
          </ng-container>
          <ng-container *ngIf="!field.limitToList">

            <mat-form-field style="width: 45%"
                            [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                            appearance="outline">
              <!--Tipo documento-->
              <mat-label>{{field.description}}</mat-label>
              <input ngModel
                     name="{{field.name}}" (ngModelChange)="this.checkComboAssociations(field);"
                     [(ngModel)]="this.comboControl[field.name]"
                     [id]="field.name" [required]="field.required" (input)="checkField(field)"
                     [disabled]="field.locked" [ngModelOptions]="{standalone: true}"
                     maxlength="{{field.numMaxChar || 100}}" matInput
                     placeholder="{{field.description}}" [matAutocomplete]="auto">
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
                                [displayWith]="displayFn.bind(this, field)">
                <ng-container *ngFor="let value of this.comboValues[field.name]">
                  <mat-option *ngIf="value.visible"
                              [value]="value">
                    {{value.selectField}}
                  </mat-option>
                </ng-container>

              </mat-autocomplete>
              <!--<mat-select [id]="field.name" [value]="field.value || ''"
                          [required]="field.required" (selectionChange)="this.checkFormula()"
                          (selectionChange)="this.checkComboAssociations(field)"
                          [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                          [disabled]="field.locked">
                <mat-option>--Cancella--</mat-option>
                <mat-option *ngFor="let value of this.comboValues[field.name]"
                            [value]="value.keyField">
                  {{value.selectField}}
                </mat-option>

              </mat-select>-->

            </mat-form-field>
          </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'AdditionalFieldDateTimeDTO'">
          <mat-form-field *ngIf="field.value == '0001-01-01T00:00:00'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                          appearance="outline"
          >
            <!--AdditionalFieldDateTimeDTO-->
            <mat-label>{{field.description}}</mat-label>
            <input style="color:#29648A;" [value]="field.value || ''" matInput
                   [matDatepicker]="picker" onkeydown="return false;"
                   [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                   [id]="field.name" [required]="field.required" (dateChange)="this.checkInputFormula()"
                   [disabled]="field.locked" (click)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker disabled="{{field.locked}}" #picker color="primary"></mat-datepicker>

          </mat-form-field>
          <mat-form-field *ngIf="field.value != '0001-01-01T00:00:00'" [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                          appearance="outline"
          >
            <!--AdditionalFieldDateTimeDTO-->
            <mat-label>{{field.description}}</mat-label>
            <input style="color:#29648A;" [value]="'' || ''" matInput
                   [matDatepicker]="picker" onkeydown="return false;"
                   [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                   [id]="field.name" [required]="field.required" (dateChange)="this.checkInputFormula()"
                   [disabled]="field.locked" (click)="picker.open()">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker disabled="{{field.locked}}" #picker color="primary"></mat-datepicker>

          </mat-form-field>
        </ng-container>
        <!--AdditionalFieldIntDTO-->
        <ng-container *ngSwitchCase="'AdditionalFieldIntDTO'">
          <mat-form-field [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"

                          appearance="outline">
            <mat-label>{{field.description}}</mat-label>
            <input ngModel [value]="field.value || ''"
                   [id]="field.name" type="number" [required]="field.required"
                   [disabled]="field.locked"
                   [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                   maxlength="{{field.numMaxChar || 100}}" matInput
                   placeholder="{{field.description}}">
          </mat-form-field>
        </ng-container>
        <ng-container *ngSwitchCase="'AdditionalFieldDoubleDTO'">
          <mat-form-field [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}"
                          appearance="outline"
          >
            <mat-label>{{field.description}}</mat-label>
            <input ngModel [value]="field.value"
                   [id]="field.name" type="text" [required]="field.required"
                   [disabled]="field.locked"
                   [(ngModel)]="dataMaskToSave[field.name]" name="{{field.name}}"
                   maxlength="{{field.numMaxChar || 100}}" matInput
                   placeholder="{{field.description}}">
          </mat-form-field>
        </ng-container>
        <!-- AdditionalFieldClasseDTO -->
        <ng-container *ngSwitchCase="'AdditionalFieldClasseDTO'">
          <div class="classBox">

            <div>
              <h4 style="float:left; color: {{this.apiService.dashColor}}">{{field.description}} </h4>
              <button *ngIf="mapClasseBookToSave.get(field.name).length > 0"
                      style="float:right; color:{{this.dashColor}};" title="{{'labels.seeMasks' | translate}}"
                      (click)="openClassMasks(field)" mat-icon-button
                      aria-label="icon-button send">
                <mat-icon [matBadge]="mapClasseBookToSave.get(field.name).length">
                  preview
                </mat-icon>
              </button>
              <button style="float:right; color:{{this.dashColor}};"
                      title="{{'labels.insertMask' | translate}}"
                      (click)="insertMaskFromClassDTO(field)" mat-icon-button
                      aria-label="icon-button send">
                <mat-icon>post_add</mat-icon>
              </button>
              <!--<button style="float:right; color:{{this.dashColor}};"
                       title="Cerca maschera"
                       (click)="searchMaskFromClassDTO(field)" mat-icon-button
                       aria-label="icon-button send">
                   <mat-icon>search</mat-icon>
               </button>-->
            </div>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <mat-form-field
            [ngClass]="{
   'form-field': field.columns !== 1,
   'form-field-expanded': field.columns === 1
}" appearance="outline">
            <mat-label>{{field.description}}</mat-label>
            <input matInput placeholder="{{field.description}}">
          </mat-form-field>
        </ng-container>
      </ng-container>
    </ng-container>
    <!--/mat-grid-list-->
    <mat-card-actions style="width: 100%;
    margin-top: 5%;">
      <button mat-stroked-button style="width: 100%; color: green; margin: 0px !important;"
              (click)="this.saveMask()">Inserisci rapportino
      </button>
    </mat-card-actions>
    <i aria-hidden="true"></i>
    <i aria-hidden="true"></i>

  </form>

</div>

